import React, { useEffect } from 'react';

// MANAGERS
import { Logger, LoggerLevel, LoggerSource } from '@Managers/Logger';

// MODULES
import LoggerFilter from './Logger.filter';
import LoggerLogs from './Logger.logs';

// CSS
import styles from './LoggerStatus.scss';

function LoggerStatus() {
    useEffect(() => {}, []);

    return (
        <div className={styles.logger_container}>
            <div>
                <LoggerLogs />
            </div>
            <div>
                <LoggerFilter />
            </div>
        </div>
    );
}

export default LoggerStatus;
